// SECTION 1
gsap.set(".co-services-1", { opacity: 0, transition: 0 });
gsap.to(".co-services-1", { 
    opacity: 1,
    duration: 1
});
document.addEventListener("DOMContentLoaded", function (event) {
  window.requestAnimationFrame(function () {
    // SECTION 2
    gsap.set(".co-services-2", { opacity: 0, transition: 0 });
    gsap.to(".co-services-2", { 
        opacity: 1,
        duration: 1
    });
    gsap.to(".co-services-2-right img", {
      scrollTrigger: {
        // markers: true,
        trigger: ".co-services-2",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      yPercent: -50
    });
    // SECTION 3
    gsap.to(".co-services-3-item", {
      scrollTrigger: {
        trigger: ".co-services-3-item",
        start: "15% bottom",
        end: "bottom top",
      },
      opacity: 1,
      duration: 1,
      stagger: 0.15
    });
    // *
    gsap.to(".co-services-4-frame>svg", {
      scrollTrigger: {
        // markers: true,
        trigger: ".co-services-4",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      yPercent: 7
    });
    // *
    gsap.to(".co-services-4-ani>*", {
      scrollTrigger: {
        trigger: ".co-services-4-content",
        start: "15% bottom",
        end: "bottom top",
      },
      opacity: 1,
      duration: 1,
      stagger: 0.15
    });
    // *
    gsap.to(".co-services-5", {
      scrollTrigger: {
        trigger: ".co-services-5",
        start: "0% bottom",
        end: "bottom top",
      },
      opacity: 1,
      duration: 1,
    });
    gsap.to(".co-services-5-right-frame img", {
      scrollTrigger: {
        // markers: true,
        trigger: ".co-services-5-right-frame",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      yPercent: -5
    });

  });
});